import React, { useEffect } from 'react'
import useInvoiceBillDownloadStyles from './styles'
import InvoiceBill from '../PlantBusinessView/components/InvoiceBill/InvoiceBill'
import { GetlogPlant, GetMonthlyInvoice } from '../../services/api'
import { useLocation } from 'react-router-dom'

const InvoiceBillDownload = () => {
  const classes = useInvoiceBillDownloadStyles()
  const { state } = useLocation()
  const [DeemedLogList, setDeemedLogList] = React.useState([])
  const [invoiceReportList, setInvoiceReportList] = React.useState([])

  useEffect(() => {
    const plantId = state?.state?.data?.id

    GetMonthlyInvoice(
      plantId,
      state?.token,
      state?.Fromdate,
      state?.Todate
    ).then((resp) => {
      if (resp) {
        setInvoiceReportList(resp?.data)
      } else {
      }
    })

    GetlogPlant(plantId, state?.token).then((resp) => {
      if (resp?.data) {
        setDeemedLogList(resp?.data)
      } else {
      }
    })
  }, [])

  const DeemedlogData = DeemedLogList.filter(
    (item) => item.plant === state?.state?.data?.id
  )

  return (
    <div className={classes.root}>
      <InvoiceBill
        DeemedlogData={DeemedlogData}
        invoiceReportList={invoiceReportList}
        invoiceDate={state?.invoiceDate}
        state={state?.state}
      />
    </div>
  )
}

InvoiceBillDownload.propTypes = {}

export default InvoiceBillDownload
